import React from 'react';
import { Icon } from '@iconify/react';

export const formatDepartmentOption = (opt, meta) => {
  if (!opt) return null;

  const path = Array.isArray(opt.pathLabel) ? opt.pathLabel : [];
  const parentTrail = path.length > 1
    ? path.slice(0, -1).filter(Boolean).join(' › ')
    : opt.parentName || '';
  const fullLabel = opt.fullLabel || (parentTrail ? `${parentTrail} › ${opt.label}` : opt.label);

  if (meta?.context === 'value') {
    return fullLabel;
  }

  return (
    <div className="d-flex align-items-center justify-content-between gap-2">
      <div className="d-flex align-items-center gap-2">
        {opt.parentId ? (
          <span className="badge bg-neutral-400 ms-2">
            <Icon icon="mdi:store" className="icon text-xl line-height-1" />
          </span>
        ) : (
          <span className="badge bg-secondary ms-2">
            <Icon icon="mdi:factory" className="icon text-xl line-height-1" />
          </span>
        )}
        <span>{opt.label}</span>
      </div>
      {parentTrail && (
        <span className="text-muted small text-end" style={{ maxWidth: '60%' }}>
          {parentTrail}
        </span>
      )}
    </div>
  );
};
